import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { Box, Container } from "@mui/material";
import CheckoutConfirmation from "../Confirmation";

const ReorderConfirmation: React.FC = () => {
  const location = useLocation();
  const orderData = (location.state as any)?.orderData;

  if (!orderData) {
    return <Navigate to="/history" replace />;
  }

  const order = orderData;
  const productOrder = order.products?.[0];
  const product = productOrder?.product;

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="md">
        <CheckoutConfirmation
          product={product?.name || ""}
          quantity={productOrder?.quantity || 1}
          address={order.fulfillment_address || ""}
          deliveryInfo={{
            deliveryMethod: order.deliveryMethod,
            addressString: order.fulfillment_address,
            needByDate: order.needBy,
            isAsap: order.isAsap,
            billingOption: order.billingOption,
            specialInstructions: order.specialInstructions,
          }}
          productDirections={{
            days: productOrder?.days_of_supply,
            refills: productOrder?.refills,
            directions: productOrder?.directions,
          }}
          strength={productOrder?.strength}
          size={productOrder?.duration}
          billingOption={order.billingOption}
          providerName={order.provider?.name}
          patients={order.patient ? [{ id: 0, name: order.patient.name, email: order.patient.email, phone: order.patient.phone }] : undefined}
        />
      </Container>
    </Box>
  );
};

export default ReorderConfirmation;
